import { createRequestHelper } from '@utils/swr'
import { type CouponSpecificProductsRequest } from '../types/apiRequest'
import { type CouponSpecificProductsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['campaignCouponSpecificProducts'], CouponSpecificProductsResponse, CouponSpecificProductsRequest>({
  client: 'fortune',
  key: params => params?.coupon_ids?.length && params.campaign_code ? `/campaigns/${params.campaign_code}/coupons/specific_products?coupon_ids=${params.coupon_ids.join(',')}` : null,
})

export const useApiCouponsSpecificProducts = useRequest
